import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
    backend: {
      // `public/locales/{{lng}}/{{ns}}.json` may be cached by client's browser
      // and might not be fetched again even after release.
      // `?` here is to trigger fetch call to new `public/locales/{{lng}}/{{ns}}.json` with new caching policy
      loadPath: 'public/locales/{{lng}}/{{ns}}.json?',
    },
  });

export default i18n;
